const enc = new TextEncoder();

const getPasswordKey = (password: string) =>
	crypto.subtle.importKey("raw", enc.encode(password), "PBKDF2", false, [
		"deriveKey",
	]);

const deriveKey = (passwordKey: CryptoKey, salt: ArrayBuffer, keyUsage: KeyUsage[]) =>
	crypto.subtle.deriveKey(
		{
			name: "PBKDF2",
			salt: salt,
			iterations: 250000,
			hash: "SHA-256",
		},
		passwordKey,
		{ name: "AES-GCM", length: 256 },
		false,
		keyUsage
	);

export async function encrypt(buf: ArrayBuffer, pw: string) {
	const salt = crypto.getRandomValues(new Uint8Array(16));
	const iv = crypto.getRandomValues(new Uint8Array(12));
	const passwordKey = await getPasswordKey(pw);
	const aesKey = await deriveKey(passwordKey, salt.buffer, ["encrypt"]);
	const encryptedContent = await crypto.subtle.encrypt(
		{
			name: "AES-GCM",
			iv: iv,
		},
		aesKey,
		buf
	);

	const encryptedContentArr = new Uint8Array(encryptedContent);
	let dec = new Uint8Array(
		salt.byteLength + iv.byteLength + encryptedContentArr.byteLength
	);
	dec.set(salt, 0);
	dec.set(iv, salt.byteLength);
	dec.set(encryptedContentArr, salt.byteLength + iv.byteLength);
	return dec;
}

export async function decrypt(buf: ArrayBuffer, pw: string) {
	const salt = buf.slice(0, 16);
	const iv = buf.slice(16, 16 + 12);
	const data = buf.slice(16 + 12);
	const passwordKey = await getPasswordKey(pw);
	const aesKey = await deriveKey(passwordKey, salt, ["decrypt"]);
	const decryptedContent = await crypto.subtle.decrypt(
		{
			name: "AES-GCM",
			iv: iv,
		},
		aesKey,
		data
	);
	return decryptedContent;
}
